import React, { useEffect } from "react";
import { ConversationForm } from "./common";
import contactData from "../data/contactData.json";

export default function ContactPopup({ isOpen, onClose }) {
  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onClose]);

  if (!isOpen) {
    return null;
  }

  return (
    <>
      <div className="modal fade show footer-contact-modal" tabIndex="-1" role="dialog" aria-modal="true"  >
        <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <button type="button" className="btn-close" aria-label="Close" onClick={onClose} />
            <div className="row">
              <div className="col-lg-5">
                <div className="footer-contact-modal-img">
                  <img src="/assets/images/amneet.webp" alt="Amneet Kaur" />
                </div>
              </div>
              <div className="col-lg-7">
                <div className="footer-contact-modal-form">
                  <ConversationForm  idPrefix="popup-conversation" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <button type="button" className="footer-contact-backdrop" aria-label="Close modal" onClick={onClose} />
      </div>
    </>
  );
}
